import { render, staticRenderFns } from "./InputLanguage.vue?vue&type=template&id=499316c6"
import script from "./InputLanguage.vue?vue&type=script&lang=js"
export * from "./InputLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports